export default "__VITE_ASSET__ea7c0432__"